import React from 'react';

export default class Footer extends React.Component
{
	
    render() {
        return (
			<footer className="footer mt-auto fhide">
                <div className="container text-center">
                    <p>Copyright © 2022 Faster Ship Log.</p>
                </div>
            </footer>
        );
    }

}
